// libs
import React, { memo } from 'react';

// styles
import { Container, SelectedIcon, OutOfStock, SelectedOverlay } from './styles';

// components
import Image from 'shared/components/ImageV2';

// defs
import { IColorOption } from 'shared/components/ColorSwatchesPDP/types';

interface ColorItemProps {
  item: IColorOption;
  onItemClick: (colorOption: IColorOption) => void;
}

const OUT_OF_STOCK_TEXT = 'Sold Out';
const IMAGE_WIDTH = '84';

function ColorItem({ item, onItemClick }: ColorItemProps) {
  return (
    <Container
      className={'color-item'}
      onClick={() => onItemClick(item)}
      isSelected={item.isSelected}
      data-test="color-item"
    >
      <Image
        src={item.imageUrl}
        alt={item.name || ''}
        aspectRatio={item.aspectRatio}
        // @ts-ignore
        width={IMAGE_WIDTH}
        lazy={true}
        data-at="color-shade-image"
      />

      {item.isSelected && (
        <>
          <SelectedOverlay />
          <SelectedIcon />
        </>
      )}

      {item.inStock === false && <OutOfStock>{OUT_OF_STOCK_TEXT}</OutOfStock>}
    </Container>
  );
}

export default memo(ColorItem);
